import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getDepartmentId, getTenantId } from 'src/app/services/store-snapshot.service';
import { FormDataService } from 'src/app/shared/attachments/service/form-data.service';
import { IdName } from 'src/app/shared/models/id-name';
import { environment } from 'src/environments/environment';
import { IServiceReport } from '../models/service-report.model';

@Injectable({
  providedIn: 'root',
})
export class ServiceReportApiService {
  private readonly baseUrl = `${environment.apiUrl}/api`;

  private get url(): string {
    return `${this.baseUrl}/${getTenantId()}/${getDepartmentId()}/ServiceReports`;
  }

  constructor(private http: HttpClient) {}

  getServiceReportById(id: string): Observable<IServiceReport> {
    const url = `${this.url}/${id}`;
    return this.http.get<IServiceReport>(url);
  }

  createServiceReport(serviceReport: IServiceReport): Observable<IServiceReport> {
    const formData = FormDataService.mapToFormDataWithSpareParts(serviceReport);
    return this.http.post<IServiceReport>(this.url, formData);
  }

  updateServiceReport(serviceReport: IServiceReport): Observable<IServiceReport> {
    const formData = FormDataService.mapToFormDataWithSpareParts(serviceReport);
    return this.http.put<IServiceReport>(this.url, formData);
  }

  deleteServiceReport(id: string, removeChemicalExposureLog?: boolean): Observable<void> {
    const url = `${this.url}/${id}`;
    if (removeChemicalExposureLog === undefined) {
      return this.http.delete<void>(url);
    }

    const params = new HttpParams().set(
      'RemoveChemicalExposureLogs',
      `${removeChemicalExposureLog}`
    );
    return this.http.delete<void>(url, { params });
  }

  printServiceReport(id: string): Observable<Blob> {
    const url = `${this.url}/${id}/Print`;
    return this.http.get(url, { responseType: 'blob' });
  }

  loadServiceReportsForIO(): Observable<IdName[]> {
    const url = `${this.url}/Interconnected`;
    return this.http.get<IdName[]>(url);
  }
}
